import { render } from "./FormLayout.vue?vue&type=template&id=4b40ec45"
import script from "./FormLayout.vue?vue&type=script&lang=js"
export * from "./FormLayout.vue?vue&type=script&lang=js"
script.render = render

export default script